import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";

import { isFetching } from "@multiweb/reactCore/fetching";
import { IAppState, NoneOwnProps } from "@multiweb/types/react";
import { createLoadNextNotificationItemsPageAction } from "../../actions";
import { FETCHING_KEY_NOTIFICATION_ITEMS } from "../../constants";
import { getInjectedComponentOnRender, ReplaceableComponentNames } from "../../customization/internalIndex";
import { getFocusedNotificationIndex } from "../../navigation";
import {
    allNotificationItemsLoaded,
    getActiveNotificationGroupTitle,
    getNotificationItemIds,
    isNotificationGroupEmpty,
} from "../../selectors";
import { NotificationListComponentProps } from "../NotificationListComponent";

type StateProps = Pick<
    NotificationListComponentProps,
    "notificationItemIds" | "hasNextPage" | "isNextPageLoading" | "emptyNotificationGroup" | "title" | "focusedItemIndex"
>;

type DispatchProps = Pick<NotificationListComponentProps, "loadNextPage">;

const mapStateToProps: MapStateToProps<StateProps, NoneOwnProps, IAppState> = (state) => ({
    notificationItemIds: getNotificationItemIds(state),
    hasNextPage: !allNotificationItemsLoaded(state),
    isNextPageLoading: isFetching(state, FETCHING_KEY_NOTIFICATION_ITEMS),
    emptyNotificationGroup: isNotificationGroupEmpty(state),
    title: getActiveNotificationGroupTitle(state),
    focusedItemIndex: getFocusedNotificationIndex(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, NoneOwnProps> = {
    loadNextPage: createLoadNextNotificationItemsPageAction,
};

export const NotificationList = connect(mapStateToProps, mapDispatchToProps)(getInjectedComponentOnRender(ReplaceableComponentNames.NotificationListComponent));
